import { ChooseMultiple, nodeWithListener } from './chooseMultiple'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'
import { parseJSON } from './utils/parseJSON'
import { getCheckedBoxes } from './utils/getCheckedBoxes'
import { GetAttr } from './utils/getAttr'
import { bubble } from './utils/bubble'
import { dispatchAjaxContentLoaded } from './generic/evented'
import { getCfg } from './utils/getCfg'
import { RangeSliderCollection } from './rangeSlider'
import { CustomSelectWithSelectric } from './customSelect'
import SyncManager from './syncManager'
import { render } from './utils/render'

export const clearBtn = '[data-js-filter-clear-btn]'

export default class CatalogFilter {

  els = {
    form: '[data-js-catalog-form]',
    filterId: '[data-js-filter-id]',
    filterValue: '[data-js-filter-value]',
    filtersContainer: '[data-js-filters-container]',
    clearBtn: clearBtn,
    clearAllBtn: '[data-js-filter-clear-all-btn]',
    goBackBtn: '[data-js-filter-goback]',
    clearContainer: '[data-js-filter-clear-container]',
    shadowWrap: '.shadow-wrap',
    shadowWrapFilter: '.shadow-wrap-filter',
    observableEl: '[data-js-filter-loading-observer]',
    loaderObserver: '[data-js-filter-observer-loader]',
    dynamicPagination: '[data-js-filter-dynamic-pagination]'
  }

  stateClasses = {
    activeCheckbox: 'filter__btn_selected',
    isDisabled: 'is-disabled',
    isHidden: 'shadow-wrap-filter--is-hidden',
  }

  attrs = {
    disableOther: 'data-js-filter-disable-other',
    defaultItem: 'data-js-filter-default-item',
    catalogForm: 'data-js-catalog-form',
    triggerSubmitAfterChange: 'data-js-filter-trigger-submit-after-change',
    clearAllBtn: 'data-js-filter-clear-all-btn',
    uncheckLinkedField: 'data-js-filter-uncheck-linked-field'
  }

  filterStateKey = 'isActiveFilter'

  states = {
    filter: {
      isSubmiting: false
    }
  }

    collapseActions = {
        collapse: "collapse",
        expand: "expand"
    }

    static bubbles = {
        newCatalogTable: 'trigger::newCatalogTable',
        expandCollapses: 'catalogFilter::expandCollapses',
    }

    static instance;

  constructor () {
    CatalogFilter.instance = this;
    this.resultData = []
    this.clearBtnCollection = [...document.querySelectorAll(this.els.clearBtn)]
    this.clearContainersCollection = [...document.querySelectorAll(this.els.clearContainer)]
    this.filters = document.querySelectorAll(this.els.filterId)
    this.setInitialFiltersState()
    this.form = document.querySelector(this.els.form)
    if(!!this.form) {
      this.cfg = getCfg(this.form, `[${this.attrs.catalogForm}]`, {})
    }
    this.goBackButton = document.querySelector(this.els.goBackBtn)

    this.observableEl = document.querySelector(this.els.observableEl) //элемент для отслеживания intersection observer
    this.loaderObserver = document.querySelector(this.els.loaderObserver) //индикатор подгрузки данных
    this.paginationByObserver = document.querySelector(this.els.dynamicPagination)

    if (this.observableEl && this.loaderObserver) {
      this.setupIntersectionObserver()
    }

    this.boundhandleFilterChange = this.handleFilterChange.bind(this)
    this.bindEvents()
  }

  reloadFilters () {
    this.unbindFilterEvents()
    this.filters = document.querySelectorAll(this.els.filterId)
    this.setInitialFiltersState()
    this.bindFilterEvents()
  }

  clearAllFilters (e) {
    this.clearBtnCollection.forEach(btn => {
      this.clearFilters({ target: btn, isTriggeredByClearAllBtn:true })
    })
    const { target } = e
    const cleatBtnCfg  = getCfg(target, this.els.clearAllBtn, {})
    if (cleatBtnCfg?.isSubmitAfterClear) {
      this.triggerSubmit()
    }
  }

  setInitialFiltersState () {
    this.filters.forEach(item => {
      item[this.filterStateKey] = !!getCheckedBoxes(item).length
      if (item.hasAttribute(this.attrs.disableOther)) {
        this.manageOtherFilterState(item)
      }
    })
  }

  clearFilters ({ target, isTriggeredByClearAllBtn=false }) {
    let targetContainer = this.clearContainersCollection.find(container => {
      return parseJSON(container.dataset.jsFilterClearContainer).containerId === JSON.parse(target.closest(this.els.clearBtn).dataset.jsFilterClearBtn).target
    })
    let filterLink
    try {
      filterLink = target.closest(this.els.filtersContainer).querySelector(this.els.filterId)
    } catch (e) {
      filterLink = null
    }

    if (targetContainer) {
      let fields = []
      switch (parseJSON(targetContainer.dataset.jsFilterClearContainer).type) {
        case 'check':
          fields = [...targetContainer.querySelectorAll('input[type="checkbox"]')]
          fields.forEach(field => {
            field.checked = false
            this.uncheckLinkedField(field)
            field.closest('.filter__btn')?.classList?.remove(this.stateClasses.activeCheckbox)
            field?.attributes?.hasOwnProperty(nodeWithListener) ? ChooseMultiple.unsetBubble(field) : false
          })
          break
        case 'radio':
          fields = targetContainer.querySelectorAll('input[type="radio"]')
          fields.forEach(field => {
            field.checked = field.hasAttribute(this.attrs.defaultItem)
          })
          break
        case 'input':
          fields = targetContainer.querySelectorAll('input[type="text"]')
          fields.forEach(field => {
            field.value = ''
          })
          break
        case 'select':
          fields = [...targetContainer.querySelectorAll('select')].filter(node => node.value !== 'none')
          fields.forEach(field => {
            field.value = 'none'
            $(field).selectric('destroy')
            $(field).selectric({
              onInit: function () {
                $('.selectric-items').find('ul').addClass('catalog__select-items')
                $('.selectric').addClass('catalog-select select_custom catalog__select')
                $('.button').addClass('select_custom__catalog-icon')
              }
            })
          })
          break
      }
      //очиста rangenouislider элементов
      const rangeSliderEls = targetContainer.querySelectorAll('[data-js-rangeslider-cfg]')
      if (rangeSliderEls) {
        [...rangeSliderEls].map((el) => {
          bubble(el, RangeSliderCollection.bubbles.reset)
        })
      }

      if (!isTriggeredByClearAllBtn) { //если это не кнопка очистить все фильтры
        //тригер submit если в конфиге есть на это указание
        if (getCfg(target.closest(this.els.clearBtn), this.els.clearBtn)?.isSubmitAfterClear) {
          this.triggerSubmit()
        }
      }
    }

    this.resetPagination();

    filterLink ? $(document).trigger('trigger::clear-filters-row', [filterLink]) : false

  }

  getFieldsValue () {
    this.getCheckboxesValue()
    this.getSelectsValue()
    this.getInputsValue()
  }

  getTokenValue() {
    const csrfTokenParamValue = document.querySelector('meta[name="csrf-token"]')?.content || ""
    if (!!csrfTokenParamValue) {
      return {
        "_csrf": csrfTokenParamValue
      }
    } else {
      return null;
    }
  }

  /**
   * @param filterId {String}
   * @param value {Object}
   * */

  addCatalogFormData (filterId, value) {
    if (!this.catalogFormData.hasOwnProperty(filterId)) {
      this.catalogFormData[filterId] = []
    }
    this.catalogFormData[filterId].push(value)
  }

  getCheckboxesValue () {
    //TODO DE ищу только у формы
    // let allCheckBoxes = [...document.querySelectorAll(`${this.els.form} input[type=checkbox]`)].filter(item => item.checked)
    let allCheckBoxes = Array.from(this.form.elements).filter(element => element.tagName === 'INPUT' && element.type === "checkbox" && element.checked)

    //TODO DE ищу у формы radio
    //let allRadio = [ ...document.querySelectorAll(`${ this.els.form } input[type=radio]`) ].filter(item => item.checked)
    let allRadio = Array.from(this.form.elements).filter(element => element.type === 'radio' && element.checked)

    allCheckBoxes.forEach((checkbox) => {
      let filterType = checkbox.closest(this.els.filterId).dataset.jsFilterId
      this.addCatalogFormData(filterType, { filterId: checkbox.id, value: true })
    })

    allRadio.forEach((checkbox) => {
      let filterType = checkbox.closest(this.els.filterId).dataset.jsFilterId
      this.addCatalogFormData(filterType, { filterId: checkbox.id, value: true })
    })
  }

  getSelectsValue () {
    //TODO DE ищу у формы селекты
    // let allSelectsBoxes = document.querySelectorAll(`${ this.form.ele } select`)
    let allSelectsBoxes = Array.from(this.form.elements).filter(element => element.tagName === 'SELECT')

    allSelectsBoxes.forEach((select) => {
      let filterType = select.closest(this.els.filterId).dataset.jsFilterId
      this.addCatalogFormData(filterType, { filterId: select.id, value: select.value })
    })
  }

  getInputsValue () {
    //TODO DE ищу у формы input
    //let allInputsBoxes = document.querySelectorAll(`${this.els.form} input[type="text"]`)
    let allInputsBoxes = Array.from(this.form.elements).filter(element => element.tagName === 'INPUT' && element.type === "text")
    allInputsBoxes.forEach((input) => {
      let filterType = input.closest(this.els.filterId).dataset.jsFilterId
      this.addCatalogFormData(filterType, { filterId: input.id, value: input.value })
    })

  }

  /**
   * @param inputData {Object}
   * @param isAppendData{Boolean}
   * */

  static insertDataFromQuery (inputData, isAppendData = false) {
    try {
      let tableWrapper = document.querySelector('.shadow-wrap')
      //TODO DE для первого шага надо добавлять к текущей верстке, а не заменять все, что есть. Мы просто подгружаем новые оправы.

      // TODO DE подойдёт ли решение ниже к тому, как реализован бэк? Добавлять, если было вызвано intersectionObserver
      // if(!!isAppendData) {
      //   render(tableWrapper, inputData.data)
      // } else {
      //   tableWrapper.innerHTML = inputData.data
      // }
      tableWrapper.innerHTML = inputData.data
      // $(document).trigger('trigger::newCatalogTable')
      bubble(document, CatalogFilter.bubbles.newCatalogTable, tableWrapper)
    } catch (err) {
      console.debug('Error in request data')
    }
  }

  triggerSubmit(isObserverReq=false) {
    bubble(this.form, "form::valid", {isObserverReq})
  }

  async formSubmit (event) {
    let isObserverReq = event.detail?.isObserverReq ?? false
    if (!this.states.filter.isSubmiting) {
      this.states.filter.isSubmiting = true
      event.preventDefault()
      const ajaxUrl = event.target.dataset.jsAjaxUrl
      const isHide = event.target.dataset.jsHide

      this.catalogFormData = {}
      this.getFieldsValue()

      const token = this.getTokenValue();
      if(!!token && this.cfg?.isAddToken) {
        this.catalogFormData = {
          ...this.catalogFormData,
          ...token
        }
      }

      //Запрос за данными на первом шаге при скроле
      if (isObserverReq) {
        Preloader.display("observerLoader", this.loaderObserver)
        this.incrementPagination()
      }

      let reqData;
      // TODO DE делаю get запрос для dev, на проде будет post
      if (process.env.NODE_ENV === "development") {
        console.debug(this.catalogFormData)
        reqData = await FetchData.getData(ajaxUrl, !isObserverReq)
      } else {
        reqData = await FetchData.postData(this.catalogFormData, ajaxUrl, !isObserverReq)
      }

      if (isObserverReq) {
        Preloader.hide(this.loaderObserver.querySelector(".spinner--observer"))
      }

      if (reqData) {
        reqData.hasOwnProperty('query') ? history.pushState(null, '', `?${reqData.query}`) : false
        CatalogFilter.insertDataFromQuery(reqData)
        // TODO DE нужен ли флаг?
        // CatalogFilter.insertDataFromQuery(reqData, !!isObserverReq)
        dispatchAjaxContentLoaded({...reqData, context: document})
        this.reloadFilters()
      } else {
        //если был запрос обсервером и он не удался, возвращаем значение пагинации
        if (isObserverReq) {
          this.decrementPagination()
        }
      }

      if (reqData && isHide) {
        this.toggleFilterDisplay()
      }

      Preloader.hide()
      this.toggleCollapses()
    }

  }

  toggleCollapses(action = this.collapseActions.collapse) {
    $('.filter').each(function() {
      const $card = $(this).closest('.card');

      $card.CardWidget(action);
    });
  }

  resetPagination() {
    this.paginationByObserver && (this.paginationByObserver.value = 1)
  }

  incrementPagination() {
    this.paginationByObserver && (this.paginationByObserver.value = Number(this.paginationByObserver.value) + 1)
  }

  decrementPagination() {
    this.paginationByObserver && (this.paginationByObserver.value = Number(this.paginationByObserver.value) - 1)
  }


  toggleFilterDisplay () {
    const shadowWrapFilter = document.querySelector(this.els.shadowWrapFilter)
    shadowWrapFilter?.classList.toggle(this.stateClasses.isHidden)
  }

  handleFilterChange (e) {
    let filter
    switch (e.type) {
      case CustomSelectWithSelectric.bubbles.change:
      case RangeSliderCollection.bubbles.change:
        filter = e.detail.closest(this.els.filterId)
        break
      default:
        filter = e.target.closest(this.els.filterId)
    }

    if (filter) {
      this.uncheckLinkedField(e.target)

      const checkedBoxes = getCheckedBoxes(filter)
      if (checkedBoxes.length) {
        this.setActiveState(filter)
      } else {
        this.unsetActiveState(filter)
      }

      if (filter.hasAttribute(this.attrs.disableOther)) {
        this.manageOtherFilterState(filter)
      }
    }

    if (this.cfg?.isSubmitAfterChangeInput || filter.hasAttribute(this.attrs.triggerSubmitAfterChange)) {
      this.triggerSubmit()
    }
  }

  uncheckLinkedField (field) {
    if (!field || typeof field.hasAttribute !== 'function' || field.checked || !field.hasAttribute(this.attrs.uncheckLinkedField)) {
      return
    }

    const cfg = parseJSON(field.getAttribute(this.attrs.uncheckLinkedField))
    const { targetFilterId, targetFieldId } = cfg

    if (!targetFilterId || !targetFieldId) {
      return
    }

    const targetFilter = this.form?.querySelector(`[${GetAttr(this.els.filterId)}="${targetFilterId}"]`)
    const targetField = targetFilter?.querySelector(`[id="${targetFieldId}"]`)

    if (!targetField) {
      return
    }

    targetField.checked = false

    if (getCheckedBoxes(targetFilter).length) {
      this.setActiveState(targetFilter)
    } else {
      this.unsetActiveState(targetFilter)
    }
  }

  manageOtherFilterState (currentFilter) {
    const checkedBoxes = getCheckedBoxes(currentFilter)
    const cfg = parseJSON(currentFilter.getAttribute(this.attrs.disableOther))
    let targetFilters = []

    cfg.targetFilters.forEach(item => {
      const el = document.querySelector(`[${GetAttr(this.els.filterId)}="${item}"]`)
      if (el) {
        targetFilters.push(el)
      }
    })

    if (this.getFilterState(currentFilter)) {
      const parents = this.getArrayOfParentsCheckboxes(checkedBoxes)
      const checkedExcludedEl = cfg.excludedEls.some(el => {
        return parents.findIndex((item) => item.getAttribute(GetAttr(this.els.filterValue)) == el) > -1
      })

      if (checkedExcludedEl) {
        targetFilters.forEach(item => {
          this.enableFilter(item)
        })

      } else {
        targetFilters.forEach(item => {
          this.disableFilter(item)
        })
      }
    } else {
      targetFilters.forEach(item => {
        this.enableFilter(item)
      })
    }
  }

  disableFilter (filter) {
    filter.classList.add(this.stateClasses.isDisabled)
  }

  enableFilter (filter) {
    filter.classList.remove(this.stateClasses.isDisabled)
  }

  getArrayOfParentsCheckboxes (checkboxes) {
    return checkboxes.map(item => {
      return item.closest(this.els.filterValue)
    })
  }

  toggleFilterState (filter) {
    filter[this.filterStateKey] = !filter[this.filterStateKey]
  }

  getFilterState (filter) {
    return filter[this.filterStateKey]
  }

  setActiveState (filter) {
    filter[this.filterStateKey] = true
  }

  unsetActiveState (filter) {
    filter[this.filterStateKey] = false
  }

  goBack = async () => {
    const shadowWrap = document.querySelector(this.els.shadowWrap)

    this.toggleFilterDisplay()
    shadowWrap.innerHTML = ''
  }

  initGoBackButton = () => {
    const goBackButton = document.querySelector(this.els.goBackBtn)

    if (goBackButton) {
      document.querySelector(this.els.goBackBtn).addEventListener('click', this.goBack)
    }
  }

  setupIntersectionObserver() {
    const observerOptions = {
      root: null, // По умолчанию это viewport
      rootMargin: '0px',
      threshold: 0.3 // Порог 30%
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
    this.observer.observe(this.observableEl);
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.triggerSubmit(true);
      }
    });
  }

  bindEvents () {
    if (this.form) {
      this.form.addEventListener('form::valid', (e) => this.formSubmit(e).finally(this.states.filter.isSubmiting = false))
    }

    if (document.querySelector(this.els.clearAllBtn)) {
      document.querySelector(this.els.clearAllBtn).addEventListener('click', (e) => this.clearAllFilters(e))
    }

    this.bindFilterEvents()

    this.clearBtnCollection.forEach(node => {
      node.addEventListener('click', (e) => this.clearFilters(e))
    })

    document.addEventListener(CustomSelectWithSelectric.bubbles.change, (e) => {
      this.handleFilterChange(e)
    })


    document.addEventListener(RangeSliderCollection.bubbles.change, (e) => {
      this.handleFilterChange(e)
    })

    document.addEventListener("SyncManager::syncWithMain", (e) => {
      this.triggerSubmit()
    })

    $(document).off(CatalogFilter.bubbles.newCatalogTable, this.initGoBackButton)
    $(document).on(CatalogFilter.bubbles.newCatalogTable, this.initGoBackButton)
    document.addEventListener(CatalogFilter.bubbles.expandCollapses, () => this.toggleCollapses(this.collapseActions.expand))
  }

  unbindFilterEvents () {
    this.filters.forEach(item => {
      item.removeEventListener('change', this.boundhandleFilterChange)
    })
  }

  bindFilterEvents () {
    this.filters.forEach(item => {
      item.addEventListener('change', this.boundhandleFilterChange)
    })
  }
}
